/**
 * @generated SignedSource<<051a4e82d90ea04319d6c614a7c08339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModal_RecordingsRenderer_note$data = {
  readonly __typename: string;
  readonly id: string;
  readonly meetingRecordings?: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContainerModalNote_note" | "MeetingContainerTabs_note" | "TranscriptModalContent_note" | "TranscriptModalHeader_note">;
  readonly " $fragmentType": "TranscriptModal_RecordingsRenderer_note";
};
export type TranscriptModal_RecordingsRenderer_note$key = {
  readonly " $data"?: TranscriptModal_RecordingsRenderer_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_RecordingsRenderer_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModal_RecordingsRenderer_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecording",
          "kind": "LinkedField",
          "name": "meetingRecordings",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "Note",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptModalContent_note"
    },
    {
      "condition": "public",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingContainerModalNote_note"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingContainerTabs_note"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranscriptModalHeader_note"
        }
      ]
    }
  ],
  "type": "INote",
  "abstractKey": "__isINote"
};
})();

(node as any).hash = "1e95083d65ac9a03b5eced25ffe2b8e7";

export default node;
